<template>
  <div style="height: 300px;" class="mt-4">  
      <v-chart class="chart" :option="option"  @ready="onReady" />
 </div>     
</template>
<script>

export default {
   components: {
    
  },
  name: 'chart-pie',
  data() {
    return {
      option: {
       
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [
            "Direct",
            "Email",
            "Ad Networks",
            "Video Ads",
            "Search Engines",
          ],
        },
        series: [
          {
            name: "Traffic Sources",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  mounted: function () 
    {
      

    },
  methods : {
     onReady(instance) {
      this.ins = instance;
    },

   }
}
</script>


// WEBPACK FOOTER //
// src/components/Charts/Pie.vue